import React, { ComponentProps } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FaThumbsUp } from 'react-icons/fa';

type ButtonProps = React.ComponentProps<typeof Button>;

type Props = ButtonProps & {
  loading?: boolean;
  text?: string;
};

const ButtonApprove = ({
  loading = false,
  text,
  type = 'button',
  variant = 'outline-success',
  onClick,
  ...rest
}: Props) => {
  const { t, i18n } = useTranslation();
  text = i18n.language === 'en' ? t('Approve') : t('Αποδοχή');

  return (
    <Button {...rest} variant={variant} type={type} onClick={onClick}>
      {loading ? (
        <Spinner animation="border" size="sm" className="mb-1 me-2" />
      ) : (
        <FaThumbsUp className="mb-1 me-2" />
      )}
      {text}
    </Button>
  );
};

export default React.memo(ButtonApprove);
